import { Action } from "redux"

import * as actions from "./actions"

export const initialState: Addins.Addins = {
    addins: [],
    isLoading: false,
}

const handlers: {
    [action: string]: (state: Addins.Addins, props: Action) => Addins.Addins
} = {
    [actions.REQUEST_ADDINS]: (state): Addins.Addins => ({
        ...state,
        isLoading: true,
    }),
    [actions.RECEIVE_ADDINS]: (
        state,
        { addins }: actions.ReceiveAddinsAction,
    ): Addins.Addins => ({
        ...state,
        addins: addins.map((addin: Addins.Addin) => ({
            addInName: addin.addInName,
            addInId: addin.addInId,
            addInVersion: addin.addInVersion,
            diff: {
                lastChangeTime: addin.diff.lastChangeTime,
                installationTime: addin.diff.installationTime,
                changes: addin.diff.changes,
            },
        })),
        isLoading: false,
    }),
}

export default function reducer(
    state: Addins.Addins = initialState,
    action: Action,
): Addins.Addins {
    const handler: (state: Addins.Addins, action: Action) => Addins.Addins =
        handlers[action.type]
    return handler ? handler(state, action) : state
}
